<template>
  <Navigation />
  <router-view v-slot="{ Component }">
    <transition
      name="slide"
      mode="out-in"
    >
      <component :is="Component" />
    </transition>
  </router-view>
</template>

<script>
import Navigation from '@/components/Navigation'
import getUser from '@/store'
import { provide } from 'vue'
export default {
  components: { Navigation },
  setup () {
    provide('currentUser', getUser)
  }
}
</script>
<style>
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
.app {
  background: #f1f1f1;
  position: relative;
}
.hero-container {
  padding: 0 20px;
  margin: 0 auto;
  max-width: 960px;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.slide-enter-active,
.slide-leave-active {
  transition: opacity 0.7s, transform 0.7s;
}
.slide-enter,
.slide-leave-to {
  opacity: 0;
  transform: translateX(-30%);
}
</style>
